import React, { useCallback, useEffect, useState } from "react";
import { Modal, Input, Select, Button, Form, notification,message, DatePicker, Upload } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_CONVERTER, CONFIGURATION_EXCEL } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../Common/APIConstants";
import * as XLSX from "xlsx";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { adjustTimeByFiveHoursThirtyMinutes, generatedISOFormatDateString } from "../../Utils/DateConverstion";


const ExcelPopupContent = ({
  onClose, 
  isAdd,
  refetchData ,
  form,
  refetch,
  setRefetch,
  handleClose
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [modules, setModules] = useState([]) 
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const modeselect = useSelector((state) => state.darkMode);
  const { isdarkMode } = modeselect;
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const handleClear = () => {
    form.resetFields();
    handleClose()
  };

  const handleNotification = (msg, type = "success") => {
    notification.open({
      message: msg,
      type: type, 
      placement: 'topRight',  
      duration: 3, 
    });
  };
  

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);




  const handleAddFormSubmit = (values) => {
    console.log(values);
    // handleOk();
    insertGroup();
    onClose()
    // form.resetFields();
    handleClear()
     setSelectedFileName(null);
          setRowData([]);
          setColumnDefs([]);
  };

  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`
    }).then((res) => {
      if(res&&res.length){
        setModules(res)
      }
      console.log("Get Modules :", res);
    })
  }

  useEffect(() => {
    getModules()
  }, [])

 


  const insertGroup = () => {
    // console.log(formValues);
    const dummy = 
    [
      {
        "meterID": 0,
        "productionValue": 0,
        "createdOn": "2025-04-08T11:14:04.881Z"
      },
    {
        "meterID": 0,
        "productionValue": 0,
        "createdOn": "2025-04-08T11:14:04.881Z"
      },
    {
        "meterID": 0,
        "productionValue": 0,
        "createdOn": "2025-04-08T11:14:04.881Z"
      }
    ]
    console.log(selectedDate)
    console.log(generatedISOFormatDateString(new Date(selectedDate)))
    console.log(adjustTimeByFiveHoursThirtyMinutes(new Date(selectedDate)))
    const bodyData = rowData.map((item) => (
      {
        "productionValue":item["Production Value"]?Number(item["Production Value"]):item["Production Value"],
        // "createdOn":selectedDate ,
        "createdOn":adjustTimeByFiveHoursThirtyMinutes(new Date(selectedDate)) ,
        "meterID":item["Meter ID"]?Number(item["Meter ID"]):item["Meter ID"],
      }
))
const cleanedData = bodyData.map(item => ({
  ...item,
  meterID: isNaN(item.meterID) ? 0 : item.meterID,
  createdOn: item.createdOn
  // createdOn: new Date(item.createdOn).toISOString()
}));
// {
//   productionValue: 13267,
//   createdOn: '2025-4-12T00:00:00.000Z',
//   meterID: 34
// },
 
    console.log(bodyData)
    console.log(cleanedData)
    const url = `${APIConstants.INSERT_IGARASHI_PRODUCTION_DATA}`;
    console.log(url);
  
    makeRequest({
      type: APIConstants.POST,
      url: url,
      body:cleanedData,
    }).then((res) => {
      console.log( res);
      if (res && res.message) {
        // handleNotification("Converter successfully saved!", "success");
        handleNotification(res.message,"success");
        setRefetch(!refetch)  
      } 
    }).catch((err) => {
      console.error(err);
      handleNotification("An error occurred while saving the converter.", "error");
    });
  };


 

// const handleExcelRead = useCallback((file) => {
//   const reader = new FileReader();

//   reader.onload = (event) => {
//     try {
//       const data = new Uint8Array(event.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const worksheet = workbook.Sheets[workbook.SheetNames[0]];

//       // Step 1: Extract raw rows
//       const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
//       console.log("📄 rawRows:", rawRows);

//       // Step 2: Find first non-empty row as header
//       const headerRow = rawRows.slice( 1).find(row =>
//         Array.isArray(row) && row.some(cell => cell?.toString().trim() !== "")
//       );

//       if (!headerRow) {
//         console.error("❌ No valid header row found.");
//         return;
//       }

//       const headerIndex = rawRows.indexOf(headerRow);
//       console.log("🔠 Header Row:", headerRow);

//       const dataRowsRaw = rawRows.slice(headerIndex + 1);
//       console.log("🧾 Raw Data Rows:", dataRowsRaw);

//       console.log(headerRow)
//       // Normalize headers
//       const normalizedHeaders = headerRow.map(h =>
//         h?.toString().toLowerCase().replace(/[^a-z0-9]/gi, "").trim()
//       );
//       console.log("🔤 Normalized Headers:", normalizedHeaders);

//       // Identify relevant header keys
//       const meterIdIndex = normalizedHeaders.findIndex(h => ["METER ID", "meterid"].includes(h));
//       const productionValIndex = normalizedHeaders.findIndex(h => ["Production Value", "productionvalue"].includes(h));

// console.log(meterIdIndex, productionValIndex)
//       if (meterIdIndex === -1 || productionValIndex === -1) {
//         console.error("❌ Required columns not found: 'Meter ID' or 'Production Value'");
//         return;
//       }

//       // Step 3: Create formatted rows
//       const formattedRows = dataRowsRaw.map(row => ({
//         "Meter ID": row[meterIdIndex] ?? "",
//         "Production Value": row[productionValIndex] ?? ""
//       })).filter(row =>
//         row["Meter ID"].toString().trim() !== "" || row["Production Value"].toString().trim() !== ""
//       );

//       console.log("✅ Final Row Data:", formattedRows);

//       // Step 4: Set data to AG Grid
//       setColumnDefs([
//         { field: "Meter ID", headerName: "Meter ID", sortable: true, filter: true },
//         { field: "Production Value", headerName: "Production Value", sortable: true, filter: true }
//       ]);
//       setRowData(formattedRows);
//     } catch (err) {
//       console.error("💥 Error while parsing Excel:", err);
//     }
//   };

//   if (file instanceof File) {
//     reader.readAsArrayBuffer(file);
//   } else {
//     console.warn("⚠️ File is not a valid File instance.");
//   }
// }, []);

const handleExcelRead = useCallback((file) => {
  const reader = new FileReader();

  reader.onload = (event) => {
    try {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      let headerRowIndex = -1;
      let normalizedHeaders = [];

      for (let i = 0; i < rawRows.length; i++) {
        const row = rawRows[i];
        const norm = row.map(cell =>
          cell?.toString().toLowerCase().replace(/[^a-z0-9]/gi, "").trim()
        );

        if (norm.some(h => h.includes("meter")) && norm.some(h => h.includes("production"))) {
          headerRowIndex = i;
          normalizedHeaders = norm;
          break;
        }
      }

      if (headerRowIndex === -1) {
        console.error("❌ No valid header row found.");
         handleNotification("⚠️ Not a valid file.",'error');
          setRowData([]);
        return;
      }

      const dataRowsRaw = rawRows.slice(headerRowIndex + 1);
      const meterIdIndex = normalizedHeaders.findIndex(h => h.includes("meter"));
      const productionValIndex = normalizedHeaders.findIndex(h => h.includes("production"));

      const formattedRows = dataRowsRaw.map(row => {
        return {
          "Meter ID": row[meterIdIndex]?.toString().trim() ?? "",
          "Production Value": row[productionValIndex]?.toString().trim() ?? ""
        };
      }).filter(row =>
        row["Meter ID"] !== "" || row["Production Value"] !== ""
      );

      setColumnDefs([
        {
          field: "Meter ID",
          headerName: "Meter ID",
          headerClass: "grid-table-header",
          sortable: true,
          filter: true,
          flex: 1,
        },
        {
          field: "Production Value",
          headerName: "Production Value",
          headerClass: "grid-table-header",
          sortable: true,
          filter: true,
          flex: 1,
        },
      ]);

      setRowData(formattedRows);
    } catch (err) {
      console.error("💥 Error parsing Excel file:", err);
       setRowData([]);
    }
  };

  if (file instanceof File) {
    reader.readAsArrayBuffer(file);
  } else {
    console.warn("⚠️ Not a valid file.");
    handleNotification("⚠️ Not a valid file.",'error');
  }
}, []);




  const handleFileChange = (info) => {
    const file = info.file.originFileObj || info.file;
    if (file) {
      setSelectedFileName(file.name);
      handleExcelRead(file);
    }
  };
  const defaultColDef = {
    sortable: true,
    // editable: true,
    flex: 1,
    minWdth: 170,
  };

  console.log(rowData)
  const row = rowData.map((item) => (
        {
          meterID:item["Meter ID"],
          productionValue:item["Production Value"],
          createdOn:selectedDate,
        }
  ))
  console.log(row)
  console.log(columnDefs)
  console.log(rowData)
  console.log(selectedFileName) 

  return (

  //   <Form
  //   form={form}
  //   onFinish={handleAddFormSubmit}
  //   name="add-group-form"
  //   className="font-bold w-[350px]"
  //   layout="horizontal"
  //   initialValues={{}}
  //   style={{ maxWidth: 400 }}
  //   labelCol={{
  //     span: 8,
  //     offset: 0,
  //   }}
  //   labelAlign="left"
  // >
  //   <Form.Item
  //     label="Excel File"
  //     name="excel"
  //     valuePropName="fileList"
  //     getValueFromEvent={(e) => {
  //       const file = e?.file;
  //       if (file) setSelectedFileName(file.name);
  //       return e && e.fileList;
  //     }}
  //     rules={[{ required: true, message: "Please upload an Excel file" }]}
  //   >
  //     <Upload
  //       accept=".xls,.xlsx"
  //       beforeUpload={() => false} // Prevent automatic upload
  //       showUploadList={false}
  //     >
  //       {selectedFileName ? (
  //         <div className={`${isdarkMode? " text-white":" text-black"}   font-medium truncate max-w-[200px] `}>{selectedFileName}</div>
  //       ) : (
  //         <div className={`${isdarkMode? " text-white":" text-black"} border-dashed border-2  w-56  h-10  rounded cursor-pointer flex items-center justify-center`}>
  //           📁  (Select the excel file)
  //         </div>
  //       )}
  //     </Upload>
  //   </Form.Item>

  //   <Form.Item
  //     label="Created On"
  //     name="createdOn"
  //     rules={[{ required: true, message: "Please enter Created On date" }]}
  //   >
  //     <DatePicker
  //       className={`${
  //         isdarkMode ? "datebackground dateplaceholder" : "whitemode"
  //       }`}
  //       dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"}
  //       format="YYYY-MM-DD HH:mm:ss"
  //       showTime
  //       popupClassName="custom-picker"
  //     />
  //   </Form.Item>

  //   <Form.Item className="flex justify-end">
  //     <Button htmlType="submit" className="blue-btn mr-2">
  //       Save
  //     </Button>
  //     <Button className="blue-btn" onClick={() => {
  //       setSelectedFileName(null);
  //       handleClear();
  //     }}>
  //       Clear
  //     </Button>
  //   </Form.Item>
  // </Form>


  <div div className="flex flex-col items-center justify-center h-full w-full" >
  <Form
    form={form}
    onFinish={handleAddFormSubmit}
    name="add-group-form"
    className="font-bold w-full"
    layout="horizontal"
    initialValues={{}}
    // style={{ maxWidth: 400 }}
    labelCol={{
      span: 8,
      offset: 0,
    }}
    labelAlign="left"
  >
    <Form.Item
      label="Excel File"
      name="excel"
      rules={[{ required: true, message: "Please upload an Excel file" }]}
    >
      <Upload
        accept=".xls,.xlsx"
        beforeUpload={() => false}
        showUploadList={false}
        onChange={handleFileChange}
      >
        {selectedFileName ? (
          <div
            className={`${
              isdarkMode ? "text-white" : "text-black"
            } font-medium truncate max-w-[200px]`}
          >
            {selectedFileName}
          </div>
        ) : (
          <div
            className={`${
              isdarkMode ? "text-white" : "text-black"
            } border-dashed border-2 w-56 h-10 rounded cursor-pointer flex items-center justify-center`}
          >
            📁 (Select the Excel file)
          </div>
        )}
      </Upload>
    </Form.Item>

    <Form.Item
      label="Created On"
      name="createdOn"
      rules={[{ required: true, message: "Please enter Created On date" }]}
    >
      <DatePicker
        className={`${
          isdarkMode ? "datebackground dateplaceholder" : "whitemode"
        }`}
        dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"}
        format="YYYY-MM-DD HH:mm:ss"
        showTime
        popupClassName="custom-picker"
        onChange={(date, dateString) => { 
          setSelectedDate(date); // Store the selected date
          console.log('Selected Date:', dateString);
          console.log('Selected Date:', date);
        }}
      />
    </Form.Item>

{rowData.length > 0 && (
    <div         
    className="ag-theme-alpine" 
    style={{ height: "400px", width: "100%" ,overflowX:'auto'}}>
      <AgGridReact
  // className="ag-theme-alpine"
  rowData={rowData}
  columnDefs={columnDefs}
  pagination={true}
  defaultColDef={{ resizable: true }}
   className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          // domLayout="autoHeight"
/>
    </div>
  )}

    <Form.Item className="flex justify-center mt-3">
      <Button
        className="blue-btn"
        htmlType="submit"
        onClick={() => {
          // insertGroup()
          // setSelectedFileName(null);
          // setRowData([]);
          // setColumnDefs([]);
          // handleClear();
          // handleOk()
          // handleClose()
        }}
      >
        Import
      </Button>
      {/* <Button htmlType="submit" className="blue-btn mr-2">
        Immpoey
      </Button> */}
    </Form.Item>
  </Form>

 
</div>


  )
};

const ExcelPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  updateRecord,
  title,
  refetch,
  setRefetch,
  refetchData 
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_EXCEL}/excel-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);

    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_EXCEL}`);
    form.resetFields();
  };

  return (
    <>

      <PopupUI

        popupContent={
          <ExcelPopupContent
            onClose={handleClose} 
            isAdd={isAdd}
            isUpdate={isUpdate}

            form={form}

            hasModal={true}
            title={title}
            refetchData={refetchData}
            refetch={refetch}
            setRefetch={setRefetch}
            handleClose={handleClose}
          />
        }
        key={updateRecord?.groupID}
        isAdd={isAdd}
        refetchData={refetchData}

        setIsUpdate={setIsUpdate}
        handleClose={handleClose}

        isOpen={isUpdate || isAdd}

        hasModal={true}
        title={title}
        width={1000}
      />

    </>
  );
};

export default ExcelPopup;
